import React from 'react'
import { Button, Box, Text, Icon } from '@deseretbook/react-ui'
import PropTypes from 'prop-types'
import { AUDIOBOOK_CONTROL_VIEWS } from './AudiobookControls'
import { Slider } from '../../../../dbWebUI'
import { roundTo } from '../../../../utils/roundTo'

import './PlaybackRateView.css'

// Can go from .5 to 3.5
const PLAYBACK_SPEEDS = [0.7, 1, 1.2, 1.5, 1.7, 2]

/**
 * View for when changing playback rate.
 * @returns {function} Component
 */
export default function PlaybackRateView({ onChangeView, onChangeRate, rate }) {
  /**
   * Closes current view.
   * @returns {undefined} Nothing
   */
  const close = () => onChangeView(AUDIOBOOK_CONTROL_VIEWS.control)

  /**
   * Sets the new playback rate.
   * @param {number} speed - playback rate
   */
  const changeRate = (speed) => {
    onChangeRate(speed)
    close()
  }

  /**
   * Updates the playback rate when the slider changes.
   *
   * @param {number} val - new playback rate
   */
  const handleSliderRateChange = (val) => {
    onChangeRate(val)
  }

  return (
    <Box alignItems="center" isColumn>
      <Text
        style={{
          fontFamily: 'Roboto, sans-serif',
          fontWeight: 700,
          fontSize: '18px',
        }}
      >
        Playback Speed
      </Text>
      <Box
        alignItems="center"
        justifyContent="space-between"
        isFullwidth
        style={{ margin: '16px 0' }}
      >
        <Button
          className="playback-button-incremental"
          onClick={() => {
            // Decrement by 0.05, but ensure rate doesn't go below 0.5
            const newValue = Math.max(roundTo(rate - 0.05), 0.5)

            handleSliderRateChange(newValue)
          }}
        >
          <Icon name="minus" />
        </Button>
        <Box width="212px">
          <Slider
            value={rate}
            min={0.5}
            max={3}
            step={0.05}
            onChange={(val) => handleSliderRateChange(val)}
          />
        </Box>
        <Button
          className="playback-button-incremental"
          onClick={() => {
            // Increment by 0.05, but ensure rate doesn't go above 3
            const newValue = Math.min(roundTo(rate + 0.05), 3)

            handleSliderRateChange(newValue)
          }}
        >
          <Icon name="plus" />
        </Button>
      </Box>
      <Box alignItems="center" isWrapped justifyContent="center" style={{ width: '356px' }}>
        {PLAYBACK_SPEEDS.map((speed) => (
          <Box margin={0.5} key={speed}>
            <Button
              type="button"
              onClick={() => changeRate(speed)}
              isFullwidth
              className={`playback-button-exact ${rate === speed ? 'isActive' : ''}`}
            >
              {speed}
            </Button>
          </Box>
        ))}
      </Box>
    </Box>
  )
}

PlaybackRateView.propTypes = {
  onChangeView: PropTypes.func,
  onChangeRate: PropTypes.func,
  rate: PropTypes.number,
}

PlaybackRateView.defaultProps = {
  onChangeRate: () => {},
  onChangeView: () => {},
  rate: 1,
}
